// extracted by mini-css-extract-plugin
export default {"disclaimer":"vYZ7qK","radioButton":"sSzw_z","checked":"t1jz3k","root":"lpg7nE","nextButton":"XyCfcC","optionLabel":"NAbzy8"};